import { ApiState, defaultApiState } from "../general.types";

export const mutate = (state: any, newState: ApiState<any>, statePath: string) => {
    if (newState.data !== undefined) {
        newState.success = true;
    }
    
    state[statePath] = {
        ...defaultApiState,
        ...newState
    }
}